module.exports = __webpack_public_path__ + "static/untitled-sans-web-medium-italic-e8fd5be4d7c36da4a181133c9f7bc3e3.woff2";